define('SageDotCom/Utility/PageModeHelper',['jquery'], function ($) {
    function PageModeHelper() { }

    PageModeHelper.prototype.IsLive = function IsLive() {
        return $("body").hasClass("mode-live");
    };

    PageModeHelper.prototype.IsPreview = function IsPreview() {
        return $("body").hasClass("mode-preview");
    };

    PageModeHelper.prototype.IsExperienceEditor = function IsExperienceEditor() {
        return $("body").hasClass("mode-experience-editor");
    };

    return new PageModeHelper();
});
